export const setData = (name, data) => {
  localStorage.setItem(name, data);
};

export const getData = (name) => {
  return localStorage.getItem(name);
};

export const getErrands = () => {
    let name = 'recent-errands-' + process.env.VUE_APP_MODAL
  let errands = JSON.parse(getData(name)) || new Array();

  return errands.sort((a, b) => {
    return new Date(b.insertDate) - new Date (a.insertDate);
  })
}

export const setErrand = (data) => {
    let name = 'recent-errands-' + process.env.VUE_APP_MODAL
  let maxItems = 10;
  let errands = getErrands(name);

  if (!errands.some(x => x.id == data.id)){
    errands.push(data);
  } else {
    let errand = errands.find(x => x.id == data.id);
    errand.insertDate = new Date();
  }

  if (errands.length > maxItems) {
    let oldestDate = new Date(Math.min(...errands.map(x => new Date(x.insertDate))));
    let oldestErrand = errands.filter(x => {
      let date = new Date(x.insertDate);
      return date.getTime() == oldestDate.getTime();
    })[0];

    errands = errands.filter(x => x.id != oldestErrand.id);
  }

  let serializedErrands = JSON.stringify(errands);

  setData(name, serializedErrands);
}